module.exports = __webpack_public_path__ + "img/mahidol-logo-2.a9b576a9.png";